import {
  AutomationTask,
  RequirementConditionType
} from 'services/automation/types';

export const getInitialValues = (automationTasks: AutomationTask[]) => {
  return automationTasks.map((automationTask) => ({
    id: automationTask.id,
    requirementConditions: automationTask.requirementConditions.map(
      (requirementCondition) => ({
        type: requirementCondition.type as RequirementConditionType.CONVERSATION_STATUS_CONDITION,
        conversationStatus: requirementCondition.conversationStatus,
        documentTypes: requirementCondition.documentTypes || []
      })
    ),
    action: {
      type: automationTask.action.type,
      atsRejectedReasonId: automationTask.action.atsRejectedReasonId,
      atsInterviewStageId: automationTask.action.atsInterviewStageId,
      komboRejectionReasonId: automationTask.action.komboRejectionReasonId,
      komboStageId: automationTask.action.komboStageId,
      recipientEmailAddress: automationTask.action.recipientEmailAddress
    }
  }));
};
